module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-upload', {
    staticClass: "image-uploader",
    attrs: {
      "http-request": _vm.Upload,
      "data": _vm.dataObj,
      "multiple": false,
      "show-file-list": false,
      "before-upload": _vm.beforeUpload,
      "drag": "",
      "action": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将图片拖到此处，或"), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 20,
      "percentage": _vm.progress,
      "status": "exception"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.tempUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg"
    },
    on: {
      "change": _vm.uploadInput
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dca7fb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/charts/test.vue
// module id = 1080
// module chunks = 1